import React from 'react'
import { useForm } from 'react-hook-form'
import { RegisterHeader } from '../../../Components/Index'
import "./StatusUploadRequest.scss";
import Footer from '../../../../../Layout/Footer';

interface formValues {
    nin: string;
    message: string;
  }

const StatusUploadRequest = () => {
  const { handleSubmit, register, formState: { errors } } = useForm<formValues>()
  const submit = handleSubmit((data) => processData(data))

  const processData = (data: { [x: string]: any; }) => {
    console.log(data)
  }

  return (
        <React.Fragment>
            <RegisterHeader/>
            <div className="psu-request">
                <div className="psu-request__hero">
                    <div className="container">
                        <div className="psu-request__hero-content">
                            <h1 className="psu-request__title text-white">Physical Screening Status Upload Request</h1>
                            <p className="psu-request__subtitle">
                                Submit your request to upload physical screening status documentation
                            </p>
                        </div>
                    </div>
                </div>

                <div className="psu-request__content mt-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 col-xl-7">
                                <div className="psu-request__card">
                                    <div className="psu-request__card-header">
                                        <h2 className="psu-request__card-title">Submit Your Request</h2>
                                        <p className="psu-request__card-description">
                                            Please provide your NIN and describe your request below. Our team will review and respond promptly.
                                        </p>
                                    </div>

                                    <form onSubmit={submit} className="psu-request__form">
                                        <div className="psu-request__form-group">
                                            <label htmlFor="nin" className="psu-request__label">
                                                <span className="psu-request__label-text">National Identification Number (NIN)</span>
                                                <span className="psu-request__label-required">*</span>
                                            </label>
                                            <div className="psu-request__input-wrapper">
                                                <svg className="psu-request__input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                    <circle cx="12" cy="7" r="4"></circle>
                                                </svg>
                                                <input
                                                    id="nin"
                                                    type="text"
                                                    className={`psu-request__input ${errors.nin ? 'psu-request__input--error' : ''}`}
                                                    {...register("nin")}
                                                    placeholder="Enter your 11-digit NIN"
                                                    aria-invalid={errors.nin ? "true" : "false"}
                                                    aria-describedby={errors.nin ? "nin-error" : undefined}
                                                />
                                            </div>
                                            {errors.nin && (
                                                <div id="nin-error" className="psu-request__error" role="alert">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <line x1="12" y1="8" x2="12" y2="12"></line>
                                                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                    </svg>
                                                    <span>{errors.nin.message}</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="psu-request__form-group">
                                            <label htmlFor="message" className="psu-request__label">
                                                <span className="psu-request__label-text">Request Details</span>
                                                <span className="psu-request__label-required">*</span>
                                            </label>
                                            <div className="psu-request__textarea-wrapper">
                                                <svg className="psu-request__textarea-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                                </svg>
                                                <textarea
                                                    id="message"
                                                    className={`psu-request__textarea ${errors.message ? 'psu-request__textarea--error' : ''}`}
                                                    {...register("message")}
                                                    placeholder="Describe your request in detail..."
                                                    rows={5}
                                                    aria-invalid={errors.message ? "true" : "false"}
                                                    aria-describedby={errors.message ? "message-error" : undefined}
                                                ></textarea>
                                            </div>
                                            {errors.message && (
                                                <div id="message-error" className="psu-request__error" role="alert">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <line x1="12" y1="8" x2="12" y2="12"></line>
                                                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                    </svg>
                                                    <span>{errors.message.message}</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="psu-request__form-actions">
                                            <button type="submit" className="psu-request__submit-btn">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M22 2L11 13"></path>
                                                    <path d="M22 2L15 22L11 13L2 9L22 2Z"></path>
                                                </svg>
                                                <span>Submit Request</span>
                                            </button>
                                        </div>
                                    </form>

                                    <div className="psu-request__help">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <span>Need help? Contact our support team for assistance with your request.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </React.Fragment>
  )
}

export default StatusUploadRequest
